import Controller from "./controller"

export default class PropertyController extends Controller {
  assignInputValue() {
    this.element.find("input#property_identifier").val(this.inputValue)
  }
}
